import { useToast, UseToastOptions } from '@chakra-ui/react';
import { debounce } from 'lodash';
import { useCallback, useEffect, useMemo } from 'react';

const DEFAULT_TOAST_DURATION_ERROR = 30000; // 30 seconds
const DEFAULT_TOAST_DURATION = 20000;
const DEFAULT_TOAST_DURATION_SUCCESS = 10000;
const DEFAULT_TOAST_DEBOUNCE = 1000; // 1 second

export function useToastWithDebounce(debounceMs = DEFAULT_TOAST_DEBOUNCE) {
  const toast = useToast();

  const showToastRef = useCallback(
    (props: UseToastOptions) => {
      toast(customiseProps(props));
    },
    [toast],
  );

  const showToastStable = useMemo(() => debounce(showToastRef, debounceMs), [showToastRef, debounceMs]);

  // Clean up the debounced function on unmount
  useEffect(() => {
    return () => {
      showToastStable.cancel();
    };
  }, [showToastStable]);

  return showToastStable;
}

export function useToastWithoutDebounce() {
  const toast = useToast();

  const showToastStable = useCallback(
    (props: UseToastOptions) => {
      toast(customiseProps(props));
    },
    [toast],
  );

  return showToastStable;
}

function customiseProps(props: UseToastOptions): UseToastOptions {
  return {
    ...props,
    duration:
      props.duration !== undefined
        ? props.duration
        : props.status === 'error'
          ? DEFAULT_TOAST_DURATION_ERROR
          : props.status === 'success'
            ? DEFAULT_TOAST_DURATION_SUCCESS
            : DEFAULT_TOAST_DURATION,
    isClosable: props.isClosable ?? true,
  };
}
